import Checkbox from '@mui/material/Checkbox';
import { Column, TableSelectionColumnParams } from '@models/table.model.ts';

export const getRowIdKey = <T extends { _id?: string }>(row: T): string =>
  row._id as string;

export const getSelectColumn = <T,>(
  {
    handleSelectRow,
    handleSelectAll,
    isPageAllSelected,
    isPagePartiallySelected,
    isRowSelected,
    isRowSelectable
  }: TableSelectionColumnParams<T>,
  width = 100
): Column => ({
  id: 'select',
  label: (
    <Checkbox
      className="primary-checkbox"
      checked={isPageAllSelected}
      indeterminate={isPagePartiallySelected}
      onChange={handleSelectAll}
    />
  ),
  field: 'select',
  render: (_value: unknown, row: T) => (
    <Checkbox
      className="primary-checkbox"
      checked={isRowSelected(row)}
      disabled={isRowSelectable ? !isRowSelectable(row) : false}
      onChange={() => handleSelectRow(row)}
    />
  ),
  width,
  showSort: false,
  showSearch: false,
  showFilter: false,
  disabledDrag: true
});
